import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { Step } from '@/domain/mitarbeiter/features/anlageassistent/types/types';
import { Stepper, StepperItem } from '@e2n/ui/v2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function Navigation() {
  const { ctx } = useAnlageassistentContext();
  return (
    <Stepper>
      {ctx.state.steps.map((step, index) => (
        <StepItem
          key={step.key}
          step={step}
          active={ctx.state.currentStepIndex === index}
        />
      ))}
    </Stepper>
  );
}

function StepItem({ step, active }: { step: Step; active: boolean }) {
  const { ctx } = useAnlageassistentContext();
  const ready = ctx.validateStepReady(step);

  const handleClick = () => {
    ctx.navigateToStep(step.key);
  };

  return (
    <StepperItem
      key={step.key}
      icon={<FontAwesomeIcon icon={step.icon} />}
      status={active ? 'active' : ready ? 'completed' : 'inactive'}
      className={active || ready ? 'cursor-pointer' : ''}
      onClick={handleClick}>
      {step.title}
    </StepperItem>
  );
}
